import React from "react";

export default function Logo(props) {
  return <h1>CB.com Web Development</h1>;
}
